<template>
  <chart-container
    @onPNGDownload="downloadGraphs(titleChart, 'png', downloadId)"
    :titleChart="titleChart"
    @onCSVDownload="downloadGraphs(titleChart, 'csv', downloadId)"
    @onPDFDownload="downloadGraphs(titleChart, 'pdf', downloadId)"
    @zoomEnabled="zoomEnabled"
    @zoomDisabled="zoomDisabled"
    :downloadId="downloadId"
    :specificSiteId="specificSiteId"
    :downloadShow="dataSource.categories && Object.keys(dataSource.categories).length > 0"
  >
    <span class="float-right enrol-tabs" slot="header">
      <b-tabs v-model="tabIndexTimeToActivities">
        <b-tab v-for="(tabName, index) in tabListActCountSit" :key="index" :title="tabName" />
      </b-tabs>
    </span>
    <fusioncharts style="width: 100%;" :type="type" :width="width" :height="height" :dataFormat="dataFormat" :dataSource="dataSource" dataEmptyMessage="No Data In" ref="timeActiveStatus" v-if="dataSource.categories && Object.keys(dataSource.categories).length > 0" slot="body"> </fusioncharts>
    <div slot="body" class="text-left min-height-0" v-if="dataSource.categories && Object.keys(dataSource.categories).length > 0">
      <span @click="zoomOutChart()" class="pl-10 pr-5 remove-zoom-icons">
        <img src="/static/img/icon-zoomout.svg" class="download_graph cursor_pointer" aria-haspopup="true" aria-expanded="false" title="Zoom Out" />
      </span>
      <span @click="zoomInChart()" class="remove-zoom-icons">
        <img src="/static/img/icon-zoomin.svg" class="download_graph cursor_pointer" aria-haspopup="true" aria-expanded="false" title="Zoom In" />
      </span>
    </div>
    <div v-else class="align-center p-60" slot="body">
      <div class="card-text-title no-data" v-if="dataLoaded">No Data In</div>
    </div>
  </chart-container>
</template>
<script>
import _ from "lodash";
import jspdf from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import { downloadCSV, getContrast, primaryColorFnc, getSiteID } from "../../services/visualization/data-management";
import ChartContainer from "@/components/containers/chart-container";
import * as dManagement from "@/services/visualization/new-data-management";

const isValueNaN = value => {
  return !isNaN(value) ? value : 0;
};

const dataSources = {
  chart: {
    animation: "1",
    xaxisname: "",
    yaxisname: "Number of Days",
    xAxisNameFontColor: "#959fa4",
    xAxisNameFont: "RobotoMedium",
    xAxisNameFontSize: "9px",
    labelFontSize: "10px",
    labelFont: "RobotoRegular",
    labelFontColor: "#a3a3a3",
    yAxisNameFontColor: "#a3a3a3",
    yAxisNameFont: "RobotoMedium",
    yAxisNameFontSize: "9px",
    yAxisValueFont: "RobotoMedium",
    yAxisValueFontSize: "10px",
    yAxisValueFontColor: "#a3a3a3",
    theme: "fusion",
    legendPosition: "right",
    legendItemFont: "RobotoRegular",
    legendItemFontColor: "#666669",
    legendCaptionAlignment: "center",
    baseFontSize: "10",
    tooltipBorderAlpha: "0",
    toolTipBgAlpha: "0",
    legendItemFontSize: "10px",
    scrollColor: "#cccccc",
    numVisiblePlot: "20",
    divLineAlpha: "0",
    divLineDashed: "0",
    useEllipsesWhenOverflow: "1",
    maxColWidth: "15",
    plotHighlightEffect: "fadeout",
    plotSpacePercent: 30,
    showXAxisLine: true,
    showYAxisLine: true,
    xaxislinethickness: "1",
    yaxislinethickness: "1",
    xAxisLineColor: "#b0bac9",
    yAxisLineColor: "#b0bac9",
    chartBottomMargin: "0",
    xAxisNamePadding: "5",
    decimals: 0,
    labelDisplay: "wrap",
    maxLabelHeight: "30"
  },
  categories: [],
  dataset: []
};
export default {
  components: { ChartContainer },
  props: {
    activitiesRaw: [Object, Array],
    containerClass: {
      type: String,
      default: "thread-chart",
      zoomGraphValueChild: ""
    },
    sitesSelected: { type: Array, default: () => ["all"] },
    countrySelected: { default: () => "all" },
    zoomGraphValue: { type: String, default: "" },
    containerId: { type: String },
    specificSiteId: { type: Array, default: () => {} },
    downloadId: { type: String, default: "" },
    titleChart: { type: String, default: "" },
    subtitleChart: { type: String, default: "" },
    tabListActCountSit: {
      type: [Object, Array],
      default: () => ["Activities", "Countries"]
    },
    dataLoaded: { type: Boolean, default: false },
    filterTriggered: { type: Boolean, default: false }
  },
  data() {
    return {
      series: null,
      tabIndexTimeToActivities: 0,
      type: "scrollColumn2d",
      width: "100%",
      height: "250",
      dataFormat: "json",
      dataSource: dataSources,
      zoomGraphValueChild: "",
      curZoomLevel: 0,
      maxZoomLevel: 3,
      maxColumn: 0,
      todayDate: "",
      tDateShow: true,
      getSiteID,
      xAxisName: ""
    };
  },

  watch: {
    activitiesRaw: function(newValue) {
      this.series = newValue ? dManagement.GET_TIME_ACTIVITIES_STATUS(newValue, this.countrySelected, this.sitesSelected, this.tabIndexTimeToActivities) || {} : {};
    },
    filterTriggered: function() {
      this.series = dManagement.GET_TIME_ACTIVITIES_STATUS(this.activitiesRaw, this.countrySelected, this.sitesSelected, this.tabIndexTimeToActivities) || {};
    },
    tabIndexTimeToActivities: function(newValue) {
      this.tabIndexTimeToActivities = newValue;
      this.series = dManagement.GET_TIME_ACTIVITIES_STATUS(this.activitiesRaw, this.countrySelected, this.sitesSelected, newValue) || {};
      this.generateAxisTimeActivities(newValue);
    },
    series: function(newValue) {
      if (newValue.categories) {
        this.initGraph(newValue);
      } else {
        const dataSources = {};
        dataSources.categories = null;
        this.dataSource = dataSources;
      }
    },
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250";
      }
    }
  },

  methods: {
    generateAxisTimeActivities(tab = 0) {
      let axisName = "";
      switch (tab) {
        case 0:
          axisName = "Activities";
          break;
        case 1:
          axisName = "Countries";
          break;
        case 2:
          axisName = "Sites";
          break;
        default:
          axisName = "Activities";
          break;
      }

      return axisName;
    },
    zoomEnabled() {
      this.$emit("zoomEnabled");
      this.height = "400";
      this.zoomTrigger = true;
    },
    zoomDisabled() {
      this.$emit("zoomDisabled");
      this.height = "250";
      this.zoomTrigger = false;
    },

    generateCsvHeaders(tabIndex) {
      const headers = ["Entry Completed (in days)", "Approved (in days)", "Verified (in days)", "Signed Off (in days)"];
      switch (tabIndex) {
        case 0:
          headers.unshift("Activity Name");
          break;
        case 1:
          headers.unshift("Countries");
          break;
        case 2:
          headers.unshift("Sites");
          break;
        default:
          break;
      }

      return headers;
    },

    getNumVisPlotByZoom() {
      let numVisPlot = 0;
      switch (this.curZoomLevel) {
        case 0:
          numVisPlot = 0;
          break;
        case 1:
          numVisPlot = Math.round(0.75 * this.maxColumn);
          break;
        case 2:
          numVisPlot = Math.round(0.5 * this.maxColumn);
          break;
        case 3:
          numVisPlot = Math.round(0.2 * this.maxColumn);
          break;
        default:
          break;
      }
      return numVisPlot;
    },

    zoomInChart() {
      if (this.curZoomLevel < this.maxZoomLevel) {
        this.curZoomLevel = this.curZoomLevel + 1;
        const chartRef = this.$refs.timeActiveStatus.chartObj;
        const data = chartRef.getJSONData();
        const numVisPlot = this.getNumVisPlotByZoom();
        data.chart.numvisibleplot = numVisPlot;
        chartRef.setJSONData(data);
      }
    },

    zoomOutChart() {
      if (this.curZoomLevel > 0) {
        this.curZoomLevel = this.curZoomLevel - 1;
        const chartRef = this.$refs.timeActiveStatus.chartObj;
        const data = chartRef.getJSONData();
        const numVisPlot = this.getNumVisPlotByZoom();
        data.chart.numvisibleplot = numVisPlot;
        chartRef.setJSONData(data);
      }
    },

    downloadGraphs(titleChart, type, downloadId) {
      this.todayDate = moment()
        .format("DD MMM YYYY hh:mm:ss")
        .toUpperCase();
      this.tDateShow = false;

      setTimeout(() => {
        switch (type) {
          case "csv": {
            const csvHeaders = this.generateCsvHeaders(this.tabIndexTimeToActivities);
            this.tDateShow = true;

            const csvContentArray = [];
            this.series.categories[0].category.map((row, index) => {
              const entryCompletedValue = isValueNaN(this.series.dataset[0].data[index].value);
              const approvedValue = isValueNaN(this.series.dataset[1].data[index].value);
              const verifiedValue = isValueNaN(this.series.dataset[2].data[index].value);
              const signedOffValue = isValueNaN(this.series.dataset[3].data[index].value);

              csvContentArray.push([row.label, entryCompletedValue, approvedValue, verifiedValue, signedOffValue]);
            });

            downloadCSV(titleChart, csvHeaders, csvContentArray, this.specificSiteId);
            break;
          }
          case "pdf": {
            let filename = titleChart + "_" + this.todayDate + ".pdf";
            if (this.specificSiteId && this.specificSiteId.length > 0) {
              filename = titleChart + "_" + this.todayDate + "_" + getSiteID(this.specificSiteId[0]) + ".pdf";
            }
            let container = document.querySelector("#" + downloadId);
            this.tDateShow = true;

            html2canvas(container, {
              allowTaint: true,
              logging: false,
              scrollY: -window.scrollY,
              scrollX: -window.scrollX - 6,
              onclone: function(document) {
                document.querySelectorAll(".nav-item").forEach(element => {
                  const ele = element.querySelector(".nav-link.active");
                  if (!ele) {
                    element.remove();
                  }
                });
              }
            }).then(canvas => {
              const imgData = canvas.toDataURL("image/png");
              const pdf = new jspdf("p", "mm", "a4");
              const imgProps = pdf.getImageProperties(imgData);
              const pdfWidth = pdf.internal.pageSize.getWidth();
              const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
              pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
              pdf.save(filename);
            });

            break;
          }
          case "png": {
            let container = document.querySelector("#" + downloadId);
            let filename = titleChart + "_" + this.todayDate + ".png";
            if (this.specificSiteId && this.specificSiteId.length > 0) {
              filename = titleChart + "_" + this.todayDate + "_" + getSiteID(this.specificSiteId[0]) + ".png";
            }
            this.tDateShow = true;

            html2canvas(container, {
              allowTaint: true,
              logging: false,
              scrollY: -window.scrollY,
              scrollX: -window.scrollX - 6,
              onclone: function(document) {
                document.querySelectorAll(".nav-item").forEach(element => {
                  const ele = element.querySelector(".nav-link.active");
                  if (!ele) {
                    element.remove();
                  }
                });
              }
            }).then(function(canvas) {
              const link = document.createElement("a");
              document.body.appendChild(link);
              link.download = filename;
              link.href = canvas.toDataURL("image/png");
              link.target = "_blank";
              link.click();
            });

            break;
          }
          default:
            break;
        }
      }, 1);
    },
    initGraph(newValue) {
      const { categories, dataset } = newValue;
      const datasources = _.cloneDeep(dataSources);

      dataset[0] = {
        ...dataset[0],
        plottooltext: `<span class='overall-collection-metric-tooltip completed' style='color:${getContrast(primaryColorFnc())}'>$dataValue Day(s) to $seriesName</span>`
      };

      dataset[1] = {
        ...dataset[1],
        plottooltext: `<span class='overall-collection-metric-tooltip missing' style='color:${getContrast("#cab2d6")}'>$dataValue Day(s) to $seriesName</span>`
      };

      dataset[2] = {
        ...dataset[2],
        plottooltext: `<span class='overall-collection-metric-tooltip verified' style='color:${getContrast("#a6cee3")}'>$dataValue Day(s) to $seriesName</span>`
      };
      dataset[3] = {
        ...dataset[3],
        plottooltext: `<span class='overall-collection-metric-tooltip signed-off' style='color:${getContrast("#fb9a99")}'>$dataValue Day(s) to $seriesName</span>`
      };

      if (categories && categories[0].category.length > 0) {
        datasources.categories = [...categories];
        datasources.dataset = dataset;
        this.maxColumn = categories[0].category.length;
      }

      datasources.chart.numvisibleplot = 0;
      datasources.chart.xaxisname = this.generateAxisTimeActivities(this.tabIndexTimeToActivities);

      this.dataSource = datasources;
    }
  },

  mounted() {
    if (this.series && this.series.categories) {
      this.initGraph(this.series);
    }
  }
};
</script>
<style lang="scss" scoped>
#app,
.time-to-activities-containers {
  width: 100%;
}
</style>
